module.exports = __webpack_public_path__ + "static/img/s2model5.e5eefbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/model/s2model5.png
// module id = WxVl
// module chunks = 0